(function () {
    let revisionRecordId = null;
    let revisionDebounceTimer = null;
    let isRevisionCreating = false;
    let revisionCreationPromise = null;

    // Visitor location saved to localStorage by layout/theme.liquid
    function getStoredLocation() {
        try {
            return localStorage.getItem('location') || '';
        } catch (e) {
            return '';
        }
    }

    // Called after a revision request is successfully submitted — flags the
    // Airtable record with sent_to_at so the backend can branch on its presence.
    window.markRevisionSentToAt = function () {
        const recordId = revisionRecordId;
        if (!recordId) return;

        try {
            fetch('https://webhooks.codeblue.agency/api/revision/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                keepalive: true,
                body: JSON.stringify({
                    record_id: recordId,
                    sent_to_at: true,
                    location: getStoredLocation(),
                    project: 'Signs.inc'
                })
            }).then(function (response) {
                return response.json().catch(function () { return null; });
            }).then(function (result) {
                console.log('[Revision Live Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
            }).catch(function (err) {
                console.error('[Revision Live Sync sent_to_at Exception]:', err);
            });
        } catch (err) {
            console.error('[Revision Live Sync sent_to_at Exception]:', err);
        }
    };

    // Extract form input data
    function getRevisionFormData() {
        // 1. Type of Change selection
        const typeOfChangeEl = document.querySelector('#revDropdown .rev-dropdown-option.is-selected:not([data-value=""])') || document.getElementById('revTypeOfChangeInput');
        const typeOfChangeVal = typeOfChangeEl
            ? (typeOfChangeEl.dataset.value || typeOfChangeEl.value || typeOfChangeEl.textContent || '').trim()
            : '';

        // 2. Sign Type selection
        const hiddenSignInput = document.getElementById('revSignTypeInput');
        let signTypesStr = hiddenSignInput ? hiddenSignInput.value.trim() : '';
        if (!signTypesStr && typeof getSelectedSignType === 'function') {
            signTypesStr = getSelectedSignType() || '';
        }

        // 3. Gather "WHAT WOULD YOU LIKE TO CHANGE?" text
        const detailsEl = document.getElementById('revDetails') || document.querySelector('#revisionModal textarea, #revisionModalOverlay textarea, textarea[name="change_details"], textarea[name="details_of_change"]');
        const detailsVal = detailsEl ? detailsEl.value.trim() : '';

        return {
            type_of_change: typeOfChangeVal,
            type_of_sign: signTypesStr,
            change_details: detailsVal,
            payment_url: window.location.href,
            project: 'Signs.inc' // Hardcoded Project Name for Airtable Single Select
        };
    }

    // Core Sync Function (Create or Update)
    async function syncRevisionData() {
        // Race-condition guard: Wait if initial creation request is still pending
        if (isRevisionCreating && revisionCreationPromise) {
            try {
                await revisionCreationPromise;
            } catch (e) {
                // Ignore initial error to allow retry
            }
        }

        const data = getRevisionFormData();

        // Do not submit if all fields are empty
        if (!data.type_of_change && !data.type_of_sign && !data.change_details) {
            return;
        }

        const doFetch = async () => {
            const isUpdate = Boolean(revisionRecordId);
            const endpoint = isUpdate
                ? 'https://webhooks.codeblue.agency/api/revision/update'
                : 'https://webhooks.codeblue.agency/api/revision/create';

            const payload = {
                ...data,
                location: getStoredLocation(),
                project: 'Signs.inc'
            };

            if (isUpdate && revisionRecordId) {
                payload.record_id = revisionRecordId;
            }

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (!revisionRecordId && result.record_id) {
                        revisionRecordId = result.record_id;
                        console.log('[Revision Live Sync] Created Airtable Record ID:', revisionRecordId);
                    } else {
                        console.log('[Revision Live Sync] Updated Airtable Record ID:', revisionRecordId);
                    }
                    return result;
                } else {
                    console.error('[Revision Live Sync Error]:', result);
                }
            } catch (err) {
                console.error('[Revision Live Sync Exception]:', err);
            }
        };

        const initialRecordId = revisionRecordId;
        if (!initialRecordId && !isRevisionCreating) {
            isRevisionCreating = true;
            revisionCreationPromise = doFetch().finally(() => {
                isRevisionCreating = false;
                revisionCreationPromise = null;
            });
            return revisionCreationPromise;
        } else {
            return doFetch();
        }
    }

    // Called on modal close: cancels any pending debounce so no patch fires
    // after close, sends one final "mark complete" update against the
    // record created/patched during this session (if any), then forgets the
    // record id so the next modal open starts a fresh record.
    async function completeRevisionSession() {
        if (revisionDebounceTimer) {
            clearTimeout(revisionDebounceTimer);
            revisionDebounceTimer = null;
        }

        // Wait for an in-flight creation so we don't race the completion
        // patch against a create that hasn't returned a record_id yet.
        if (isRevisionCreating && revisionCreationPromise) {
            try {
                await revisionCreationPromise;
            } catch (e) {
                // Creation itself failed — nothing to finalize.
            }
        }

        if (revisionRecordId) {
            try {
                await fetch('https://webhooks.codeblue.agency/api/revision/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        record_id: revisionRecordId,
                        status: 'Completed',
                        location: getStoredLocation(),
                        project: 'Signs.inc'
                    })
                });
                console.log('[Revision Live Sync] Marked record complete:', revisionRecordId);
            } catch (err) {
                console.error('[Revision Live Sync] Failed to mark session complete:', err);
            }
        }

        revisionRecordId = null;
    }

    // Debounced listener (Fast 500ms initial creation, 2000ms update debounce)
    function handleRevisionLiveInput() {
        clearTimeout(revisionDebounceTimer);
        const delay = revisionRecordId ? 2000 : 500;
        revisionDebounceTimer = setTimeout(() => {
            syncRevisionData();
        }, delay);
    }

    // Global Event Delegation for Revision Modal
    document.addEventListener('input', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && e.target.closest('#revisionModal, #revisionModalOverlay, #revisionForm, .revision-overlay, .rev-modal-overlay')) {
            handleRevisionLiveInput();
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target && e.target.closest('#revisionModal .rev-sign-chip, #revisionModalOverlay .rev-sign-chip, #revisionModal .sign-type-chip, #revisionModalOverlay .sign-type-chip, #revisionModal .type-select-btn, .rev-dropdown-option, .rev-dropdown-trigger')) {
            handleRevisionLiveInput();
        }
    });

    // Called on modal OPEN: starts a fresh prospect session (no network
    // call) so the very next edit creates a brand-new record instead of
    // patching whatever was synced during a previous open/close cycle.
    window.resetRevisionLiveSync = function () {
        revisionRecordId = null;
        if (revisionDebounceTimer) {
            clearTimeout(revisionDebounceTimer);
            revisionDebounceTimer = null;
        }
    };

    window.completeRevisionSession = completeRevisionSession;

    document.addEventListener('reset', (e) => {
        if (e.target && (e.target.id === 'revisionForm' || e.target.closest('#revisionForm'))) {
            if (typeof window.resetRevisionLiveSync === 'function') {
                window.resetRevisionLiveSync();
            }
        }
    });
})();